import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MdFlightTakeoff, MdFlightLand } from 'react-icons/md';
import TwSliders from '../../../../../TwSlider';
import formatMinutesToTime from '../../../../../../helpers/formatters/formatMinutesToTime';

const isFullRange = (start, end, min, max) => start === min && end === max;

const Sliders = ({
  takeoff,
  landing,
  onTakeOffChange,
  onLandingChange,
  takeoffMin,
  landingMin,
  takeoffMax,
  landingMax,
  routeLabel,
  isReturn,
}) => {
  // TODO: i think each slider needs to be a component
  // (wrapper around material slider with value etc.)
  const [displayTakeoff, setDisplayTakeoff] = useState(takeoff);
  const [displayLanding, setDisplayLanding] = useState(landing);

  const handleDisplayTakeOffChange = (event, newValue) => {
    setDisplayTakeoff(newValue);
  };

  const handleDisplayLandingChange = (event, newValue) => {
    setDisplayLanding(newValue);
  };

  const takeoffAnytime = isFullRange(displayTakeoff[0], displayTakeoff[1], takeoffMin, takeoffMax);
  const landingAnytime = isFullRange(displayLanding[0], displayLanding[1], landingMin, landingMax);

  const mirrorStyle = isReturn ? { transform: 'scaleX(-1)' } : undefined;

  return (
    <>
      {routeLabel && <div className="text-sm text-gray-700 mb-3 font-medium">{routeLabel}</div>}

      <div className="mb-4">
        <div className="flex items-center mb-2">
          <MdFlightTakeoff className="text-gray-500 text-xl mr-2" style={mirrorStyle} />
          <span className="text-sm text-gray-700">
            Departure
            {' · '}
            {takeoffAnytime
              ? 'Anytime'
              : `${formatMinutesToTime(displayTakeoff[0])} - ${formatMinutesToTime(displayTakeoff[1])}`}
          </span>
        </div>
        <TwSliders
          value={displayTakeoff}
          onChange={handleDisplayTakeOffChange}
          onChangeCommitted={onTakeOffChange}
          min={takeoffMin}
          max={takeoffMax}
          step={5}
        />
      </div>

      <div className="mb-2">
        <div className="flex items-center mb-2">
          <MdFlightLand className="text-gray-500 text-xl mr-2" style={mirrorStyle} />
          <span className="text-sm text-gray-700">
            Arrival
            {' · '}
            {landingAnytime
              ? 'Anytime'
              : `${formatMinutesToTime(displayLanding[0])} - ${formatMinutesToTime(displayLanding[1])}`}
          </span>
        </div>
        <TwSliders
          value={displayLanding}
          onChange={handleDisplayLandingChange}
          onChangeCommitted={onLandingChange}
          min={landingMin}
          max={landingMax}
          step={5}
        />
      </div>
    </>
  );
};

Sliders.displayName = 'Sliders';

Sliders.propTypes = {
  takeoff: PropTypes.arrayOf(PropTypes.number).isRequired,
  landing: PropTypes.arrayOf(PropTypes.number).isRequired,
  onTakeOffChange: PropTypes.func.isRequired,
  onLandingChange: PropTypes.func.isRequired,
  takeoffMin: PropTypes.number.isRequired,
  takeoffMax: PropTypes.number.isRequired,
  landingMin: PropTypes.number.isRequired,
  landingMax: PropTypes.number.isRequired,
  routeLabel: PropTypes.string,
  isReturn: PropTypes.bool,
};

Sliders.defaultProps = {
  routeLabel: '',
  isReturn: false,
};

export default React.memo(Sliders);
